<header>
    <button (click)="toggleSideNav()" class="toggle-sidebar"><mat-icon>menu</mat-icon></button>
    <div class="end-content">
        <button class="header-icon" #languagesButton="matMenuTrigger" [matMenuTriggerFor]="languagesMenu">
            <app-svg-icon [icon]="IconsConstants.GLOBAL_ICON"></app-svg-icon>
        </button>
    </div>
</header>

<mat-menu #languagesMenu>
    <ng-container *ngFor="let item of languageMenuItems">
      <button mat-menu-item class="menu-item" (click)="checkCurrentLanguageAndChangeIt(item.language)" [ngClass]="item.language === language ? 'current-lang' : ''">
        <span>{{'Lang.'+item.language| translate}}</span>
      </button>
    </ng-container>
</mat-menu>